import { UserData, useUsers } from '@hooks';
import { Modal } from 'antd';

interface DeleteUserModalProps {
  open: boolean;
  onCancel: () => void;
  user: UserData | null;
  onSuccess?: () => void;
}

export const DeleteUserModal = ({ open, onCancel, user, onSuccess }: DeleteUserModalProps) => {
  const { deleteUser } = useUsers();

  const handleDelete = async () => {
    if (!user) return;

    try {
      await deleteUser.mutateAsync(user.id);
      onCancel();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  return (
    <Modal
      title={<span className="!font-['Android_101'] !font-normal">CONFIRM DELETE</span>}
      open={open}
      onOk={handleDelete}
      onCancel={onCancel}
      confirmLoading={deleteUser.isPending}
      okText="Yes, delete"
      cancelText="CANCEL"
      okButtonProps={{
        className: 'bg-[#E3AF25] !text-black !border-none hover:!bg-[#E3AF25] !font-["Android_101"] hover:!translate-y-[-2px] transition-all duration-200'
      }}
      cancelButtonProps={{
        className: '!font-["Android_101"] !font-normal !text-red-500 !border-red-500 hover:!text-red-500 hover:!border-red-500 hover:!bg-transparent !uppercase hover:!translate-y-[-2px] transition-all duration-200 [&_span]:!text-red-500 [&_span]:hover:!text-red-500'
      }}
      className="[&_.ant-modal]:!rounded-none [&_.ant-modal-content]:!bg-zinc-800 [&_.ant-modal-content]:!text-white [&_.ant-modal-content]:!rounded-none [&_.ant-modal-header]:!bg-zinc-800 [&_.ant-modal-header]:!border-b-zinc-700 [&_.ant-modal-header]:!rounded-none [&_.ant-modal-title]:!text-white [&_.ant-modal-footer]:!border-t-zinc-700 [&_.ant-modal-footer]:!rounded-none [&_.ant-modal-close-x]:!text-[#E3AF25] [&_.ant-modal-close-x]:hover:!text-[#E3AF25] [&_.ant-modal-footer_.ant-btn-default]:!text-red-500 [&_.ant-modal-footer_.ant-btn-default_span]:!text-red-500 [&_.ant-modal-footer_.ant-btn-default:hover_span]:!text-red-500"
    >
      <p className="!font-['Barlow']">
        Are you sure you want to delete the user <strong>{user?.physicalPerson?.name || user?.email}</strong>? This action cannot be undone.
      </p>
    </Modal>
  );
};
